var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"main-color-bg",attrs:{"dark":"","color":"darken-4","dense":""}},[_c('GoBackButtons'),_vm._t("left"),_c('v-spacer'),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }